export default "__VITE_ASSET__44e38493__"